module.exports = __webpack_public_path__ + "resource/img/chats.9208eaba.svg";